/* eslint-disable max-len */
/* global require */
import moment from 'moment';

const packageJSON = require('../../package.json');

export default function TheSafeAppController(
  $location,
  $rootScope,
  $scope,
  appVersionDialog,
  appVersionService,
  loaderService,
  ssDialogService,
  userService,
) {
  const vm = this;
  vm.loaderService = loaderService;
  vm.currentYear = moment().year();
  vm.uxVersion = packageJSON.version;
  vm.apiVersion = '';
  $scope.$watch(
    () => $location.path(),
    (newPath, oldPath) => {
      // eslint-disable-line no-unused-vars
      if (
        newPath !== '/login' &&
        newPath !== '/password' &&
        newPath.indexOf('/id_token') === -1 &&
        newPath !== '/' &&
        newPath !== '' &&
        newPath !== '/blockActiveDirectory'
      ) {
        userService.getPortal().then(portal => {
          vm.apiVersion = portal.version;
          userService.user = portal.userInfo;
          userService.ssrsDashboardUrl = portal.ssrsDashboardUrl;
        });
      }
    },
  );
  vm.isLogin = () => $location.path() === '/login';
  vm.isPassword = () => $location.path() === '/password';

  /**
   * Display the appVersionDialog when necessary
   */
  appVersionService.subscribe({
    notify: ($event, locals) => {
      ssDialogService.dialogs.global.appVersionDialog = ssDialogService.alert(
        appVersionDialog.getOptions($event, locals),
      );
      return ssDialogService.show(ssDialogService.dialogs.global.appVersionDialog);
    },
  });
}

TheSafeAppController.$inject = [
  '$location',
  '$rootScope',
  '$scope',
  'appVersionDialog',
  'appVersionService',
  'loaderService',
  'ssDialogService',
  'userService',
];
